export function Section({ children, ...rest }) {
  return (
    <section className="my-3 container" {...rest}>
      {children}
    </section>
  )
}